<template>
    <button-tooltip bottom :tooltip="isDark ? $t('common.theme_dark') : $t('common.theme_light')">
        <template v-slot:activator="{ on, attrs }">
            <button type="button" class="theme-switch" :class="{ 'theme-switch--light': !isDark }" v-bind="attrs"
                v-on="on" @click="onToggle">
                <span class="theme-switch-knob">
                    <v-icon size="12" color="#0C0E12">{{ isDark ? 'mdi-weather-night' : 'mdi-white-balance-sunny' }}</v-icon>
                </span>
            </button>
        </template>
    </button-tooltip>
</template>

<script>
import { toggleTheme } from '@/utils/Theme'
import ButtonTooltip from '@/components/common/ButtonTooltip'

export default {
    name: 'ThemeToggle',
    components: { ButtonTooltip },
    computed: {
        isDark(vm = this) {
            return vm.$vuetify.theme.dark
        }
    },
    methods: {
        onToggle(event) {
            const target = event && event.currentTarget
            const rect = target && target.getBoundingClientRect ? target.getBoundingClientRect() : null
            const origin = rect ? { x: rect.left + rect.width / 2, y: rect.top + rect.height / 2 } : null
            toggleTheme(this.$vuetify, origin)
        }
    }
}
</script>

<style scoped>
.theme-switch {
    width: 52px;
    height: 28px;
    background: var(--v-surface2-base);
    border: 1px solid var(--v-outline2-base);
    border-radius: 14px;
    position: relative;
    cursor: pointer;
    display: flex;
    align-items: center;
    flex-shrink: 0;
    padding: 0;
}

.theme-switch-knob {
    position: absolute;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background: var(--brand-gradient);
    left: 3px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform .2s ease;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);
}

.theme-switch--light .theme-switch-knob {
    transform: translateX(24px);
}
</style>
